import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-input-error',
    template: `
        <div class="text-danger text-xs">{{ error | translate }}</div>
    `,
    imports: [TranslatePipe]
})
export class InputErrorComponent {
    @Input() error: string;
}
